// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__Es1ST","Connect":"Contact_Connect__E65SN","ContactIcons":"Contact_ContactIcons__W08lc"};